import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * 회원가입 완료 컴포넌트
 */
export function SignupComplete() {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-md mx-auto text-center">
      {/* 성공 아이콘 */}
      <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg
          className="w-12 h-12 text-green-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      {/* 메시지 */}
      <h1 className="text-3xl font-bold text-gray-900 mb-3">회원가입 완료!</h1>
      <p className="text-gray-600 mb-8 text-lg">
        회원가입이 성공적으로 완료되었습니다.
        <br />
        로그인하여 서비스를 이용해보세요.
      </p>

      {/* 버튼 */}
      <div className="space-y-3">
        <button
          onClick={() => navigate("/login")}
          className="w-full py-3 bg-[#FF7131] text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors"
        >
          로그인하기
        </button>
        <button
          onClick={() => navigate("/")}
          className="w-full py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
        >
          홈으로 가기
        </button>
      </div>
    </div>
  );
}
